import React from 'react';
import { usePreset } from '../../lib/ThemeContext';

/**
 * Typing indicator component showing animated dots
 */
export const TypingIndicator: React.FC = () => {
  const preset = usePreset();
  const isNv = preset === 'nv';
  const isNevi = preset === 'nevi';

  const dotStyle = (delay: string): React.CSSProperties => ({
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: isNv ? 'rgba(46, 46, 46, 0.4)' : isNevi ? 'rgba(251, 251, 251, 0.5)' : 'var(--wc-primary-color)',
    animation: 'wc-typing-dot 1.4s ease-in-out infinite',
    animationDelay: delay,
  });

  return (
    <div className="wc-flex wc-justify-start wc-mb-4 wc-message-appear-bot">
      <div
        className={isNv || isNevi ? '' : 'wc-bg-[var(--wc-bot-message-color)] wc-rounded-2xl wc-rounded-tl-none'}
        style={{
          padding: isNv || isNevi ? '8px 12px' : '12px 16px',
          display: 'flex',
          alignItems: 'center',
          ...(isNevi ? { background: '#2B323B', borderRadius: '16px', position: 'relative' } : {}),
        }}
      >
        {isNevi && (
          <div
            style={{ position: 'absolute', bottom: '-2px', left: '-8px', display: 'flex', alignItems: 'flex-end' }}
          >
            <div style={{ width: '6px', height: '6px', borderRadius: '16px', background: '#2B323B' }} />
            <div style={{ width: '16px', height: '16px', borderRadius: '16px', background: '#2B323B' }} />
          </div>
        )}
        <div style={{ display: 'flex', gap: '4px' }}>
          <div style={dotStyle('0ms')} />
          <div style={dotStyle('200ms')} />
          <div style={dotStyle('400ms')} />
        </div>
      </div>
    </div>
  );
};
